import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { l } from '@manychat/manyui'

import { contentManagementActions } from 'apps/cms/store'
import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { FLOW_NAME, getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { alert } from 'common/core'
import { followReplyApi } from 'shared/api/requests/followReply'
import { FailedToCreateFollowReplyFlowError } from 'shared/errors/clientLayerError'
import { createAsyncAction } from 'shared/lib/redux'

export const createFlow = createAsyncAction(
  `${NAMESPACE}/createFlow`,
  async (
    { quickCampaignId, title }: { quickCampaignId?: number; title?: string },
    { dispatch },
  ) => {
    const flowData = await dispatch(
      contentManagementActions.createAutomation({
        name: title ?? FLOW_NAME,
        quickCampaignId,
      }),
    ).unwrap()

    if (!flowData) {
      alert(l.translate('Failed to create flow'))
      throw new FailedToCreateFollowReplyFlowError()
    }

    const replacedFlowData = await followReplyApi.replaceFlow({
      body: { flow_ns: flowData.flow.ns },
    })

    return replacedFlowData.data
  },
)

export const createFlowReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(createFlow.fulfilled, (state, action) => {
    const data = action.payload
    if (data) {
      state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
    }
  })
}
